import { LegalLayout, LegalSection } from "./LegalLayout";
import { AUTHOR_EMAIL, AUTHOR_NAME } from "../lib/site";

export const PrivacyPage = () => (
  <LegalLayout title="Polityka prywatności" testid="privacy-page" updated="wrzesień 2026">
    <LegalSection title="1. Administrator danych">
      <p>
        Administratorem danych osobowych jest {AUTHOR_NAME} (kontakt:{" "}
        {AUTHOR_EMAIL}, prawodorzeczy.pl).
      </p>
    </LegalSection>

    <LegalSection title="2. Jakie dane zbieramy">
      <p>
        Strona sprzedażowa nie posiada kont użytkowników i nie zbiera danych
        przez formularze. Dane podane przy płatności (imię i nazwisko, adres
        e-mail, dane rozliczeniowe) przetwarzane są bezpośrednio przez operatora
        płatności Stripe — Sprzedawca nie ma dostępu do danych kart
        płatniczych.
      </p>
      <p>
        Jeśli kontaktujesz się z nami e-mailowo, przetwarzamy Twój adres e-mail
        i treść korespondencji.
      </p>
    </LegalSection>

    <LegalSection title="3. Cele i podstawy przetwarzania">
      <p>
        Dane przetwarzamy w celu: realizacji umowy sprzedaży i dostarczenia
        produktu (art. 6 ust. 1 lit. b RODO), wypełnienia obowiązków
        podatkowych i księgowych (art. 6 ust. 1 lit. c RODO), obsługi zapytań i
        reklamacji oraz dochodzenia roszczeń (art. 6 ust. 1 lit. f RODO).
      </p>
    </LegalSection>

    <LegalSection title="4. Odbiorcy danych">
      <p>
        Dane mogą być przekazywane: Stripe Payments Europe, Ltd. (obsługa
        płatności), dostawcy hostingu strony oraz biuru rachunkowemu — wyłącznie
        w zakresie niezbędnym do realizacji tych usług.
      </p>
    </LegalSection>

    <LegalSection title="5. Okres przechowywania">
      <p>
        Dane przechowujemy przez okres niezbędny do realizacji umowy, a
        następnie przez okres wymagany przepisami podatkowymi (co do zasady 5
        lat) lub do czasu przedawnienia ewentualnych roszczeń.
      </p>
    </LegalSection>

    <LegalSection title="6. Twoje prawa">
      <p>
        Masz prawo dostępu do swoich danych, ich sprostowania, usunięcia,
        ograniczenia przetwarzania, przenoszenia oraz wniesienia sprzeciwu.
        Przysługuje Ci również prawo wniesienia skargi do Prezesa Urzędu
        Ochrony Danych Osobowych.
      </p>
    </LegalSection>

    <LegalSection title="7. Cookies i analityka">
      <p>
        Strona może wykorzystywać anonimowe narzędzia analityczne (statystyki
        odwiedzin) oraz techniczne mechanizmy lokalnego przechowywania danych
        (np. zapamiętanie zamknięcia okna informacyjnego). Nie prowadzimy
        profilowania reklamowego.
      </p>
    </LegalSection>

    <LegalSection title="8. Kontakt">
      <p>
        We wszystkich sprawach dotyczących danych osobowych napisz na adres:{" "}
        {AUTHOR_EMAIL}.
      </p>
    </LegalSection>
  </LegalLayout>
);
